'use client';

export type Platform = 'facebook' | 'tiktok' | 'instagram' | 'youtube';
export type ServiceCategory =
  | 'followers' | 'likes' | 'comments' | 'views' |'tiktok_followers'| 'tiktok_likes' | 'tiktok_views' | 'tiktok_comments' |'instagram_followers'| 'instagram_likes' | 'instagram_views' | 'instagram_comments' |'youtube_followers' | 'youtube_likes' | 'youtube_views' | 'youtube_comments';

interface ServicesTabsProps {
  active: ServiceCategory;
  onChange: (cat: ServiceCategory) => void;
  platform: Platform;
  onPlatformChange: (p: Platform) => void;
}

const facebookTabs: { id: ServiceCategory; label: string; emoji: string }[] = [
  { id: 'followers', label: 'Abonnés', emoji: '👥' },
  { id: 'likes', label: 'Likes', emoji: '👍' },
  { id: 'comments', label: 'Commentaires', emoji: '💬' },
  { id: 'views', label: 'Vues', emoji: '👁️' },
];

const tiktokTabs: { id: ServiceCategory; label: string; emoji: string }[] = [
  { id: 'tiktok_followers', label: 'Abonnés', emoji: '👥' },
  { id: 'tiktok_likes', label: 'Likes', emoji: '❤️' },
  { id: 'tiktok_views', label: 'Vues', emoji: '▶️' },
  { id: 'tiktok_comments', label: 'Commentaires', emoji: '💬' },
];

const instagramTabs: { id: ServiceCategory; label: string; emoji: string }[] = [
  { id: 'instagram_followers', label: 'Abonnés', emoji: '👥' },
  { id: 'instagram_likes', label: 'Likes', emoji: '❤️' },
  { id: 'instagram_views', label: 'Vues', emoji: '▶️' },
  { id: 'instagram_comments', label: 'Commentaires', emoji: '💬' },
];

const youtubeTabs: { id: ServiceCategory; label: string; emoji: string }[] = [
  { id: 'youtube_followers', label: 'Abonnés', emoji: '👥' },
  { id: 'youtube_likes', label: 'Likes', emoji: '👍' },
  { id: 'youtube_views', label: 'Vues', emoji: '▶️' },
  { id: 'youtube_comments', label: 'Commentaires', emoji: '💬' },
];

export default function ServicesTabs({ active, onChange, platform, onPlatformChange }: ServicesTabsProps) {
  const tabs = platform === 'facebook' ? facebookTabs : platform === 'tiktok' ? tiktokTabs : platform === 'instagram' ? instagramTabs : youtubeTabs;

  return (
    <div className="flex flex-col items-center gap-4">
      {/* Platform selector */}
      <div
        className="inline-flex items-center p-1.5 rounded-full gap-1"
        style={{ background: 'rgba(13,27,62,0.06)', border: '1px solid rgba(13,27,62,0.08)' }}
      >
        <button
          onClick={() => { onPlatformChange('facebook'); }}
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold transition-all ${platform === 'facebook' ? 'text-white shadow-md' : 'text-[#6B7280] hover:text-[#0D1B3E]'}`}
          style={{
            background: platform === 'facebook' ? 'linear-gradient(135deg,#1877F2,#1565C0)' : 'transparent',
          }}
        >
          <span>📘</span>
          <span>Facebook</span>
        </button>
        <button
          onClick={() => { onPlatformChange('tiktok'); }}
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold transition-all ${platform === 'tiktok' ? 'text-white shadow-md' : 'text-[#6B7280] hover:text-[#0D1B3E]'}`}
          style={{
            background: platform === 'tiktok' ? 'linear-gradient(135deg,#010101,#2563EB)' : 'transparent',
          }}
        >
          <span>🎵</span>
          <span>TikTok</span>
        </button>
        <button
          onClick={() => { onPlatformChange('instagram'); }}
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold transition-all ${platform === 'instagram' ? 'text-white shadow-md' : 'text-[#6B7280] hover:text-[#0D1B3E]'}`}
          style={{
            background: platform === 'instagram' ? 'linear-gradient(135deg,#833AB4,#FD1D1D,#F77737)' : 'transparent',
          }}
        >
          <span>📸</span>
          <span>Instagram</span>
        </button>
        <button
          onClick={() => { onPlatformChange('youtube'); }}
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold transition-all ${platform === 'youtube' ? 'text-white shadow-md' : 'text-[#6B7280] hover:text-[#0D1B3E]'}`}
          style={{
            background: platform === 'youtube' ? 'linear-gradient(135deg,#CC0000,#FF0000)' : 'transparent',
          }}
        >
          <span>▶️</span>
          <span>YouTube</span>
        </button>
      </div>

      {/* Category tabs */}
      <div
        className="inline-flex items-center p-1.5 rounded-full gap-1"
        style={{ background: 'rgba(13,27,62,0.06)', border: '1px solid rgba(13,27,62,0.08)' }}
        role="tablist"
        aria-label="Catégories de services"
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={active === tab.id}
            onClick={() => onChange(tab.id)}
            className={`tab-btn flex items-center gap-2 ${active === tab.id ? 'active' : ''}`}
            style={active === tab.id && platform === 'tiktok' ? {
              background: 'linear-gradient(135deg,#010101,#2563EB)',
              color: 'white',
            } : active === tab.id && platform === 'instagram' ? {
              background: 'linear-gradient(135deg,#833AB4,#FD1D1D,#F77737)',
              color: 'white',
            } : active === tab.id && platform === 'youtube' ? {
              background: 'linear-gradient(135deg,#CC0000,#FF0000)',
              color: 'white',
            } : {}}
          >
            <span>{tab.emoji}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}